import { graphql } from "react-relay";

export const TriggerOrganizationScanMutation = graphql`
  mutation TriggerOrganizationScanMutation(
    $input: TriggerOrganizationScanInput!
  ) {
    triggerOrganizationScan(input: $input) {
      scans {
        uuid
      }
      problems {
        message
      }
    }
  }
`;
